import { StepBase } from './StepBase'
import { PageStepType } from './PageTypes';
import { StringOptions } from '../utils/StringOptions';
import { LogicEngine } from '../LogicEngine/LogicEngine';

export class StepTabs extends StepBase
{
    tabs : StepTabs.TabInfo[] = [];
    logicRef : LogicEngine | undefined;

    /** Add a tab to the list of tabs we're tracking in this holder */
    addTab(step : PageStepType)
    {
        if (!this.logicRef)
            throw "Exception: should not happen but logicRef in StepTabs is null";

        const tab :StepTabs.TabInfo = {
            text    : this.logicRef.processTextReplacement(step.text_en ? step.text_en : ""),
            type    : new StringOptions(step.step_option),
            field   : step.field_id ? step.field_id : "",
            option1 : step.option_1 ? step.option_1 : "",
            option2 : step.option_2 ? step.option_2 : ""
        }

        this.tabs.push(tab);
    }

    async processStep(logic : LogicEngine) : Promise<boolean>
    {
        this.logicRef = logic;
        return super.processStep(logic);
    }
}

export namespace StepTabs
{
    export interface TabInfo
    {
        text    : string;
        type    : StringOptions;
        field   : string;
        option1 : string;
        option2 : string;
    };
};
